const FeatureFlagConstants = {
  ZRM_AUTH_0_ENABLED: 'ZRM_AUTH_0_ENABLED',
  ZRM_AUTH_0_MFA_ENABLED: 'ZRM_AUTH_0_MFA_ENABLED',
} as const;

export default FeatureFlagConstants;
